import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=08249f06&scoped=true&lang=pug&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=08249f06&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08249f06",
  null
  
)

export default component.exports